module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    attrs: {
      "large": true
    },
    model: {
      value: (_vm.value.show),
      callback: function($$v) {
        _vm.value.show = $$v
      },
      expression: "value.show"
    }
  }, [_c('div', {
    slot: "content"
  }, [_c('div', {
    staticClass: "ls-modal-header"
  }, [_c('button', {
    attrs: {
      "close-modal": "",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "ls-modal-title"
  }, [_vm._v(_vm._s(_vm.$t('contracts.modal_taxes.title')))])]), _vm._v(" "), _c('div', {
    staticClass: "ls-modal-body"
  }, [(_vm.unlinkedTaxes.length) ? _c('h5', {
    staticClass: "ls-title-3"
  }, [_vm._v(_vm._s(_vm.$t('contracts.modal_taxes.not_applied_taxes')))]) : _vm._e(), _vm._v(" "), (_vm.unlinkedTaxes.length) ? _c('div', {
    staticClass: "ls-box max-heigth overflow-y-scroll"
  }, [_c('table', {
    staticClass: "ls-table ls-sm-space ls-table-striped"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('taxes.attributes.name')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('taxes.attributes.value')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('taxes.attributes.scope')))]), _vm._v(" "), _c('th')])]), _vm._v(" "), _c('tbody', _vm._l((_vm.unlinkedTaxes), function(tax, index) {
    return _c('tr', {
      attrs: {
        "data-test": "tax"
      }
    }, [_c('td', {
      attrs: {
        "data-test": "tax.name"
      }
    }, [_vm._v(_vm._s(tax.name))]), _vm._v(" "), _c('td', {
      staticClass: "ls-no-padding-right",
      attrs: {
        "data-test": "tax.value"
      }
    }, [_vm._v(_vm._s((tax.value)) + "%")]), _vm._v(" "), _c('td', {
      attrs: {
        "data-test": "tax.scope"
      }
    }, [_vm._v(_vm._s(tax.scope))]), _vm._v(" "), _c('td', [_c('authorized-link', {
      attrs: {
        "tag": "create_contract_tax"
      }
    }, [_c('button', {
      staticClass: "ls-btn ls-btn-primary ls-no-margin",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setContractTax(tax, index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-plus",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "ls-display-none-xs"
    }, [_vm._v(_vm._s(_vm.$t('contracts.modal_taxes.buttons.add')))])])])], 1)])
  }))])]) : _vm._e(), _vm._v(" "), (_vm.linkedTaxes.length) ? _c('h5', {
    staticClass: "ls-title-3"
  }, [_vm._v(_vm._s(_vm.$t('contracts.modal_taxes.applied_taxes')))]) : _vm._e(), _vm._v(" "), (_vm.linkedTaxes.length) ? _c('div', {
    staticClass: "ls-box max-heigth overflow-y-scroll"
  }, [_c('table', {
    staticClass: "ls-table ls-sm-space ls-table-striped"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('taxes.attributes.name')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('taxes.attributes.value')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('taxes.attributes.scope')))]), _vm._v(" "), _c('th')])]), _vm._v(" "), _c('tbody', _vm._l((_vm.linkedTaxes), function(tax, index) {
    return _c('tr', {
      attrs: {
        "data-test": "tax"
      }
    }, [_c('td', {
      attrs: {
        "data-test": "tax.name"
      }
    }, [_vm._v(_vm._s(tax.name))]), _vm._v(" "), _c('td', {
      staticClass: "ls-no-padding-right",
      attrs: {
        "data-test": "tax.value"
      }
    }, [_vm._v(_vm._s((tax.value)) + "%")]), _vm._v(" "), _c('td', {
      attrs: {
        "data-test": "tax.scope"
      }
    }, [_vm._v(_vm._s(tax.scope))]), _vm._v(" "), _c('td', [_c('authorized-link', {
      attrs: {
        "tag": "destroy_contract_tax"
      }
    }, [_c('button', {
      staticClass: "ls-btn ls-btn-danger ls-no-margin",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.disableContractTax(tax, index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "ls-display-none-xs"
    }, [_vm._v(_vm._s(_vm.$t('contracts.modal_taxes.buttons.remove')))])])])], 1)])
  }))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "ls-modal-footer"
  }, [_c('button', {
    staticClass: "ls-btn pull-right",
    attrs: {
      "close-modal": "",
      "data-dismiss": "modal"
    }
  }, [_vm._v(_vm._s(_vm.$t('application.button.close')))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-40c1f6d5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/pages/contracts/components/ModalTaxes.vue
// module id = 761
// module chunks = 1